import { writesApi } from './api';

// ── "I paid but it isn't showing" claims ───────────────────────────────────
export type PaymentClaimStatus = 'open' | 'under_review' | 'accepted' | 'rejected' | 'auto_verified';

export interface PaymentClaim {
  id: string;
  orderId: string;
  customerId: string;
  mpesaReceipt: string;
  amountPaid: number;
  paidPhone: string | null;
  proofUrl: string | null;
  customerNotes: string | null;
  status: PaymentClaimStatus;
  /** Last Daraja STK Query result: { resultCode, resultDesc, checkedAt } or { error } */
  autoCheckResult: Record<string, unknown>;
  resolution: 'order_settled' | 'wallet_credited' | null;
  resolutionNotes: string | null;
  reviewedBy: string | null;
  reviewedAt: string | null;
  paymentTransactionId: string | null;
  createdAt: string;
  updatedAt: string;
}

export const claimStatusChip: Record<PaymentClaimStatus, string> = {
  open:          'bg-[var(--state-danger-bg)] text-[var(--state-danger)]',
  under_review:  'bg-[var(--state-warning-bg)] text-[var(--state-warning)]',
  accepted:      'bg-[var(--state-success-bg)] text-[var(--state-success)]',
  auto_verified: 'bg-[var(--state-success-bg)] text-[var(--state-success)]',
  rejected:      'bg-[var(--bg-base)] text-[var(--text-muted)]',
};

// ── Service → Spring Boot :8080 (payments.process) ─────────────────────────
export const paymentClaimsService = {
  /** status: live (default) | open | under_review | accepted | rejected | auto_verified | all */
  list: (status?: string) =>
    writesApi.get<PaymentClaim[]>('/admin/payment-claims', status ? { status } : undefined),

  get: (id: string) => writesApi.get<PaymentClaim>(`/admin/payment-claims/${id}`),

  /** Re-run the Daraja STK Query. Settles automatically if Safaricom now says paid. */
  recheck: (id: string) => writesApi.post<PaymentClaim>(`/admin/payment-claims/${id}/recheck`),

  /** Honour the claim: settles the order if still open, else credits the customer wallet. */
  accept: (id: string, notes?: string) =>
    writesApi.post<PaymentClaim>(`/admin/payment-claims/${id}/accept`, { notes: notes || null }),

  reject: (id: string, reason: string) =>
    writesApi.post<PaymentClaim>(`/admin/payment-claims/${id}/reject`, { reason }),
};
